export default function formatPhoneNumber(phoneNumberWithoutDash: string, allowWrong = true) {
  if (typeof phoneNumberWithoutDash !== "string") {
    return null;
  }

  // Remove all non-digit characters
  let cleaned = phoneNumberWithoutDash.replace(/\D/g, "");

  // Validate the length (must be 10 or 11 digits)
  if (!/^01\d{8,9}$/.test(cleaned)) {
    return allowWrong ? cleaned : null;
  }

  // Match and format: 010-XXX-XXXX or 010-XXXX-XXXX
  if (cleaned.length === 10) {
    return cleaned.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
  } else if (cleaned.length === 11) {
    return cleaned.replace(/(\d{3})(\d{4})(\d{4})/, "$1-$2-$3");
  }
  return allowWrong ? cleaned : null;
}
